export default "__VITE_ASSET__c235825a__"